import React from 'react';
import AdjustmentsIcon from '@heroicons/react/outline/AdjustmentsIcon.js';
import CalendarIcon from '@heroicons/react/outline/CalendarIcon.js';
import DotsHorizontalIcon from '@heroicons/react/outline/DotsHorizontalIcon.js';
import ExternalLinkIcon from '@heroicons/react/outline/ExternalLinkIcon.js';
import PlusIcon from '@heroicons/react/outline/PlusIcon.js';
export const getIcon = (iconName) => {
    switch (iconName) {
        case 'ExternalLinkIcon':
            return React.createElement(ExternalLinkIcon, null);
        case 'PlusIcon':
            return React.createElement(PlusIcon, null);
        case 'DotsHorizontalIcon':
            return React.createElement(DotsHorizontalIcon, null);
        case 'AdjustmentsIcon':
            return React.createElement(AdjustmentsIcon, null);
        case 'Calendar':
            return React.createElement(CalendarIcon, null);
        default:
            return null;
    }
};
//# sourceMappingURL=utils.js.map